function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUcloudstack(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M17.609 11.453a1.83 1.83 0 01.243 2.445l2.118 3.66a1.83 1.83 0 11-1.471 2.55h-4.237a1.83 1.83 0 11-1.471-2.55l2.118-3.66a1.83 1.83 0 012.7-2.445zm-5.131-8.66c2.956 0 5.48 2.183 6.32 5.435 1.91.819 3.207 2.956 3.207 5.344a6.295 6.295 0 01-.83 3.156 2.813 2.813 0 00-.491-.136l-.129-.02-1.557-2.69.016-.036a2.831 2.831 0 00-4.533-3.134l-.136.13a2.832 2.832 0 00-.599 3.004l.016.036-1.557 2.69-.134.021a2.83 2.83 0 00-2.29 2.395l-.019.17-3.151.007h-.023c-2.615-.455-4.593-3.092-4.593-6.162 0-3.138 2.001-5.798 4.661-6.185 3.622 0 4.733 2.31 4.733 2.31-.635-2.31-1.765-3.526-3.596-4.174 1.251-1.888 2.615-2.16 4.685-2.16zm4.107 11.851a1.925 1.925 0 01-.205 0 1.925 1.925 0 01-.205 0l-2.118 3.66c.082.11.15.228.205.352h4.236a1.74 1.74 0 01.205-.351l-2.118-3.66z"
  }));
}

SvgUcloudstack.clsName = 'icon-www__ucloudstack';
SvgUcloudstack.remarkName = 'unknown';
export default SvgUcloudstack;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Ucloudstack.js
// module id = 2457
// module chunks = 17 18